// extracted by mini-css-extract-plugin
module.exports = {"login-form":"LoginForm_login-form__40Eo9","link":"LoginForm_link__14CsO","login-form__submit-group":"LoginForm_login-form__submit-group__23C0r"};